<template>
  <div class="gov-shell">
    <div class="gov-tab-bar" v-if="tabs.length > 0">
      <div
        class="gov-tab"
        :class="{ active: activeTab === 'home' }"
        @click="activeTab = 'home'"
      >
        <span class="tab-title">本体治理智能体</span>
      </div>
      <div
        v-for="tab in tabs"
        :key="tab.id"
        class="gov-tab"
        :class="{ active: activeTab === tab.id }"
        @click="activeTab = tab.id"
      >
        <span class="tab-title">{{ tab.title }}</span>
        <i class="el-icon-close tab-close" @click.stop="closeTab(tab.id)"></i>
      </div>
    </div>

    <!-- <div>
      <iframe
        src="https://x.test.cosmoplat.com:5173/meta-models"
        frameborder="0"
        class="ontology-iframe"
      />
    </div> -->

    <div v-show="activeTab === 'home'">
      <AgentLayout
        agentType="governance"
        title="本体治理智能体"
        description="基于本体模型与知识图谱，实现数据资产统一治理与智能管理"
        placeholder="输入本体治理问题，按 Enter 发送..."
      >
        <!-- 核心指标 -->
        <div class="stats-row">
          <div class="stat-card" v-for="(stat, index) in stats" :key="index">
            <div class="stat-icon" :style="{ background: stat.bg }">
              <i :class="stat.icon" :style="{ color: stat.color }"></i>
            </div>
            <div class="stat-info">
              <span class="stat-value">{{ stat.value }}</span>
              <span class="stat-label">{{ stat.label }}</span>
            </div>
          </div>
        </div>

        <!-- Feature cards -->
        <div class="feature-cards">
          <div style="display: none;">{{ userInfoTemp }}</div>
          <div
            v-if="showModelingCard"
            class="feature-card full-width"
            @click="handleOpenTab('modeling', '智能本体建模', '')"
          >
            <div class="feature-card-header">
              <div class="feature-card-title">
                <span class="feature-icon modeling"
                  ><i class="el-icon-setting"></i
                ></span>
                <div>
                  <h4>智能本体建模</h4>
                  <p>基于行业本体模型库，智能构建业务本体</p>
                </div>
              </div>
              <span class="feature-cta"
                >开始构建 <i class="el-icon-arrow-right"></i
              ></span>
            </div>
            <div class="steps-row">
              <div class="step-col" v-for="(step, idx) in steps" :key="idx">
                <div class="step-circle" :class="step.status">
                  {{ idx + 1 }}
                </div>
                <div class="step-content">
                  <span class="step-title">{{ step.title }}</span>
                  <span class="step-desc">{{ step.desc }}</span>
                </div>
                <div class="step-connector" v-if="idx < steps.length - 1">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    style="fill: none; stroke: #cbd5e1; stroke-width: 2"
                  >
                    <path d="M7 4l6 6-6 6" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div
            class="feature-card full-width tall"
            @click="
              handleOpenTab(
                'ontology-map',
                '本体模型',
                BIGDATA_PATHS.ontologyMap,
              )
            "
          >
            <div class="feature-card-header">
              <div class="feature-card-title">
                <span class="feature-icon ontology"
                  ><i class="el-icon-s-operation"></i
                ></span>
                <div>
                  <h4>本体模型</h4>
                  <p>展示业务实体与关系的知识图谱</p>
                </div>
              </div>
              <span class="feature-cta"
                >查看全部 <i class="el-icon-arrow-right"></i
              ></span>
            </div>
            <div class="ontology-graph-body">
              <div class="ontology-graph-wrap">
                <iframe
                  :src="iframeUrl"
                  frameborder="0"
                  class="graph-iframe"
                  @load="sendTokenToIframe($event.target)"
                ></iframe>
              </div>
            </div>
          </div>

          <div
            class="feature-card"
            @click="
              handleOpenTab(
                'datasource-manage',
                '元数据目录',
                BIGDATA_PATHS.datasource,
              )
            "
          >
            <div class="feature-card-header">
              <div class="feature-card-title">
                <span class="feature-icon metadata"
                  ><i class="el-icon-document"></i
                ></span>
                <div>
                  <h4>元数据目录</h4>
                  <p>管理数据源与数据主题下的数据表元信息</p>
                </div>
              </div>
              <span class="feature-cta"
                >查看全部 <i class="el-icon-arrow-right"></i
              ></span>
            </div>
            <div class="metadata-preview-wrap">
              <div class="metadata-preview-scroll">
                <div
                  class="metadata-row"
                  v-for="s in (dbSourceObj && dbSourceObj.datasourceList) || []"
                  :key="s.datasourceId"
                >
                  <span class="metadata-name"
                    ><i
                      class="el-icon-s-grid"
                      style="color: #4a5ff3; font-size: 12px"
                    ></i>
                    {{ s.tableName || "-" }}</span
                  >
                  <span class="metadata-count">{{
                    s.tableDescribe || "-"
                  }}</span>
                </div>
              </div>
              <div class="preview-footer">
                共 {{ (dbSourceObj && dbSourceObj.total) || 0 }} 个数据表
              </div>
            </div>
          </div>

          <div
            class="feature-card"
            @click="
              handleOpenTab(
                'industry-model-manage',
                '行业本体模型库',
                BIGDATA_PATHS.industryModel,
              )
            "
          >
            <div class="feature-card-header">
              <div class="feature-card-title">
                <span class="feature-icon library"
                  ><i class="el-icon-collection"></i
                ></span>
                <div>
                  <h4>行业本体模型库</h4>
                  <p>汇聚多行业可复用本体模型资产</p>
                </div>
              </div>
              <span class="feature-cta"
                >查看全部 <i class="el-icon-arrow-right"></i
              ></span>
            </div>
            <div class="library-preview">
              <div
                class="library-item"
                v-for="(ind, idx) in industryList"
                :key="ind.name"
              >
                <span
                  class="library-icon"
                  :style="{ background: industryIconBgs[idx % 3] }"
                >
                  <i
                    :class="industryIcons[idx % 3]"
                    style="color: #fff; font-size: 14px"
                  ></i>
                </span>
                <div class="library-info">
                  <div class="library-name">{{ ind.industryName }}</div>
                  <div class="library-desc">{{ ind.industryRemark }}</div>
                </div>
                <span class="library-obj-count">{{ ind.totalNodes }} 对象</span>
              </div>
              <div class="library-footer">
                共 {{ industryTotal.industries }} 行业 ·
                {{ industryTotal.objects }} 个本体对象
              </div>
            </div>
          </div>

          <div
            v-for="(item, gIdx) in bigdataPathArr"
            :key="item.id"
            class="feature-card"
            @click="handleOpenTab(item.id, item.title, item.url)"
          >
            <div class="feature-card-header">
              <div class="feature-card-title">
                <span
                  class="feature-icon"
                  :style="{ background: getGovernanceCardColor(gIdx) }"
                >
                  <i :class="getGovernanceCardIcon(gIdx)"></i>
                </span>
                <div>
                  <h4>{{ item.title }}</h4>
                  <p>{{ getGovernanceCardDescText(item.id) }}</p>
                </div>
              </div>
              <span class="feature-cta"
                >查看全部 <i class="el-icon-arrow-right"></i
              ></span>
            </div>
            <div class="metadata-preview-wrap">
              <div class="metadata-preview-scroll">
                <div
                  class="metadata-row"
                  v-for="(row, rIdx) in (governanceCardData[item.id] &&
                    governanceCardData[item.id].list) ||
                  []"
                  :key="rIdx"
                >
                  <span class="metadata-name"
                    ><i
                      class="el-icon-s-grid"
                      style="color: #4a5ff3; font-size: 12px"
                    ></i>
                    {{ getGovernanceCardName(item.id, row) || "-" }}</span
                  >
                  <span class="metadata-count">{{
                    getGovernanceCardDesc(item.id, row) || "-"
                  }}</span>
                </div>
              </div>
              <div class="preview-footer">
                共
                {{
                  (governanceCardData[item.id] &&
                    governanceCardData[item.id].total) ||
                  0
                }}
                个
              </div>
            </div>
          </div>
        </div>
      </AgentLayout>
    </div>

    <div
      v-for="tab in tabs"
      v-show="activeTab === tab.id"
      :key="tab.id"
      class="gov-iframe-wrap"
    >
      <div style="background: #fff; height: 100%">
        <ModelingDrawer v-if="tab.id === 'modeling'" />
        <iframe
          v-else
          :src="tab.url"
          frameborder="0"
          class="gov-iframe"
          @load="onIframeLoad($event, tab)"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import AgentLayout from './agentLayout.vue'
import ModelingDrawer from './ModelingDrawer.vue'
import { BIGDATA_PATHS, BIGDATA_GOVERNANCE_MAP } from './bigdataPath'
import { getToken } from '@/utils/auth'
import moment from 'moment/moment'

const INDUSTRY_ICONS = [
  'el-icon-s-home',
  'el-icon-s-goods',
  'el-icon-s-platform'
]

export default {
  name: 'HomeAgentPage',
  components: { AgentLayout, ModelingDrawer },
  data() {
    return {
      BIGDATA_PATHS,
      stats: [
        {
          icon: 'el-icon-s-custom',
          value: '—',
          label: '实体节点',
          bg: '#EEF2FF',
          color: '#4A5FF3'
        },
        {
          icon: 'el-icon-connection',
          value: '—',
          label: '关系数量',
          bg: '#FFF3E0',
          color: '#FF9800'
        },
        {
          icon: 'el-icon-s-grid',
          value: '—',
          label: '数据表',
          bg: '#E3F2FD',
          color: '#2196F3'
        }
      ],
      steps: [
        {
          title: '选择行业模板',
          desc: '从制造业、化工、\nPCBA中选择模板',
          status: 'done'
        },
        {
          title: '匹配业务对象',
          desc: '自动匹配业务\n对象与属性关系',
          status: 'active'
        },
        {
          title: '生成本体模型',
          desc: '基于模板构建\n企业级本体模型',
          status: 'active'
        },
        { title: '确认模型', desc: '审核确认\n本体模型', status: 'active' }
      ],
      dbSourceObj: { datasourceList: [], total: 0 },
      industryList: [],
      industryIcons: INDUSTRY_ICONS,
      industryIconBgs: [
        'linear-gradient(135deg, #4E86FF, #4A5FF3)',
        'linear-gradient(135deg, #36CFB0, #0EA582)',
        'linear-gradient(135deg, #F7A852, #F57C3A)'
      ],
      loading: true,
      iframeUrl: BIGDATA_PATHS.ontologyMap,
      activeTab: 'home',
      tabs: [],
      bigdataPathArr: BIGDATA_GOVERNANCE_MAP,
      governanceCardData: {
        relationModel: { list: [], total: 0 },
        metaCollect: { list: [], total: 0 },
        metaModels: { list: [], total: 0 },
        polymorphicMeta: { list: [], total: 0 },
        bloodAnalysis: { list: [], total: 0 },
        standardFile: { list: [], total: 0 },
        standardList: { list: [], total: 0 },
        standardRelation: { list: [], total: 0 },
        qualityWork: { list: [], total: 0 },
        dataAuth: { list: [], total: 0 },
        qualityTest: { list: [], total: 0 },
        dataMaskingRules: { list: [], total: 0 },
        dataMaskingConfig: { list: [], total: 0 },
      },
      showModelingCard: false,
      userInfoTemp: null,
    };
  },
  methods: {
    sendTokenToIframe(iframe) {
      console.log('[  ]-403---------------------------')
      const token = getToken()
      if (!token) return
      console.log('[ token ]-404', token)
      iframe.contentWindow.postMessage(
        JSON.stringify({
          action: 'token_send',
          payload: {
            token,
            expireAt: Date.now()
          },
          timestamp: Date.now()
        }),
        '*'
      )
    },
    onIframeLoad(event, tab) {
      this.sendTokenToIframe(event.target)
    },
    handleOpenTab(id, title, url) {
      const exists = this.tabs.find((t) => t.id === id)
      if (!exists) {
        this.tabs.push({ id, title, url: url || '' })
      }
      this.activeTab = id
      if (url) {
        this.$nextTick(() => {
          setTimeout(() => {
            const iframe = this.$el.querySelector('.gov-iframe')
            if (iframe) this.sendTokenToIframe(iframe)
          }, 300)
        })
      }
    },
    closeTab(id) {
      const idx = this.tabs.findIndex((t) => t.id === id)
      if (idx === -1) return
      this.tabs.splice(idx, 1)
      if (this.activeTab === id) {
        this.activeTab = this.tabs.length
          ? this.tabs[this.tabs.length - 1].id
          : 'home'
      }
    },
    getGovernanceCardIcon(idx) {
      const icons = [
        'el-icon-connection',
        'el-icon-download',
        'el-icon-s-grid',
        'el-icon-s-operation',
        'el-icon-share',
        'el-icon-document',
        'el-icon-tickets',
        'el-icon-link',
        'el-icon-circle-check',
        'el-icon-lock',
        'el-icon-search',
        'el-icon-view',
        'el-icon-setting'
      ]
      return icons[idx] || 'el-icon-s-data'
    },
    getGovernanceCardColor(idx) {
      const colors = [
        'linear-gradient(135deg, #4e86ff, #4a5ff3)',
        'linear-gradient(135deg, #36CFB0, #0EA582)',
        'linear-gradient(135deg, #F7A852, #F57C3A)',
        'linear-gradient(135deg, #7C3AED, #A78BFA)',
        'linear-gradient(135deg, #EC4899, #F472B6)',
        'linear-gradient(135deg, #06B6D4, #22D3EE)',
        'linear-gradient(135deg, #8B5CF6, #C084FC)',
        'linear-gradient(135deg, #F43F5E, #FB7185)',
        'linear-gradient(135deg, #10B981, #34D399)',
        'linear-gradient(135deg, #3B82F6, #60A5FA)',
        'linear-gradient(135deg, #F59E0B, #FBBF24)',
        'linear-gradient(135deg, #6366F1, #818CF8)',
        'linear-gradient(135deg, #14B8A6, #2DD4BF)'
      ]
      return colors[idx] || colors[0]
    },
    getGovernanceCardDescText(id) {
      const map = {
        relationModel: '管理数据表之间的关系模型',
        metaCollect: '管理和监控元数据采集作业',
        metaModels: '定义和管理元数据模型',
        polymorphicMeta: '管理多态化元数据资源',
        bloodAnalysis: '分析和追溯数据血缘关系',
        standardFile: '管理数据标准文件',
        standardList: '定义和管理数据标准',
        standardRelation: '管理标准与数据表的关联关系',
        qualityWork: '监控和管理数据质量作业',
        dataAuth: '管理数据访问权限和用户组',
        qualityTest: '管理数据质量检测执行与结果查看',
        dataMaskingRules: '定义和管理数据脱敏规则',
        dataMaskingConfig: '配置数据脱敏规则与数据的关联'
      }
      return map[id] || ''
    },
    getGovernanceCardName(id, row) {
      const map = {
        relationModel: row.name || row.modelName,
        metaCollect: row.name || row.jobName,
        metaModels: row.name,
        polymorphicMeta: row.dataName,
        bloodAnalysis: row.jobName || row.name,
        standardFile: row.standardName,
        standardList: row.zhName || row.standardName,
        standardRelation: row.tableName,
        qualityWork: row.jobName,
        dataAuth: row.cnname || row.name,
        qualityTest: row.name,
        dataMaskingRules: row.name,
        dataMaskingConfig: row.name
      }
      return map[id] || ''
    },
    getGovernanceCardDesc(id, row) {
      const map = {
        relationModel: moment(row.updateTime).format('YYYY-MM-DD HH:mm:ss'),
        metaCollect: moment(row.updateTime).format('YYYY-MM-DD HH:mm:ss'),
        metaModels:
          row.type === 1
            ? '表级'
            : row.type === 2
              ? '字段级'
              : row.type || row.typeName,
        polymorphicMeta: moment(row.updateTime).format('YYYY-MM-DD HH:mm:ss'),
        bloodAnalysis: moment(row.updateTime).format('YYYY-MM-DD HH:mm:ss'),
        standardFile: row.standardType || '-',
        standardList: row.standardFileName || row.statusName,
        standardRelation: row.standardName || row.tableDescribe,
        qualityWork: row.jobDescription || '-',
        dataAuth: moment(row.updateTime).format('YYYY-MM-DD HH:mm:ss'),
        qualityTest: moment(row.updateTime).format('YYYY-MM-DD HH:mm:ss'),
        dataMaskingRules: moment(row.updateTime).format('YYYY-MM-DD HH:mm:ss'),
        dataMaskingConfig: moment(row.updateTime).format('YYYY-MM-DD HH:mm:ss')
      }
      return map[id] || ''
    },
    async defaultFetch(url, id) {
      try {
        const res = await fetch(url, {
          headers: { Authorization: 'Bearer ' + getToken() }
        })
        const data = await res.json()
        const list =
          data?.data?.records ||
          data?.data?.list ||
          data?.data ||
          data?.records ||
          []
        const total = data?.data?.total || data?.total || list.length || 0
        this.governanceCardData[id] = {
          list: Array.isArray(list) ? list : [],
          total
        }
      } catch (e) {
        /* ignore */
      }
    },
    async defaultPost(url, body, id) {
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + getToken()
          },
          body: JSON.stringify(body)
        })
        const data = await res.json()
        const list = data?.data?.records || data?.records || data?.data || []
        const total =
          data?.data?.total ||
          data?.total ||
          (Array.isArray(list) ? list.length : 0)
        this.governanceCardData[id] = {
          list: Array.isArray(list) ? list : [],
          total
        }
      } catch (e) {
        /* ignore */
      }
    },
    fetchAllGovernanceData() {
      // const userInfo = window.microApp.getData().userInfo;
      this.defaultFetch(
        '/tianshu-api/bigdata/tablerelation/relationmodel/page?pageNum=1&pageSize=5',
        'relationModel'
      )
      this.defaultPost(
        '/tianshu-api/bigdata/metadata/collect/job/page',
        { pageNum: 1, pageSize: 5 },
        'metaCollect'
      )
      this.defaultFetch(
        '/tianshu-api/bigdata/metaDataTemp/queryList?pageNum=1&pageSize=5',
        'metaModels'
      )
      this.defaultPost(
        '/tianshu-api/bigdata/polymorphicDataTable/page',
        { pageNum: 1, pageSize: 5 },
        'polymorphicMeta'
      )
      this.defaultPost(
        '/tianshu-api/bigdata/portal/lineage/lineageTask/page',
        { pageNum: 1, pageSize: 5 },
        'bloodAnalysis'
      )
      this.defaultPost(
        '/tianshu-api/bigdata/standard/file/page',
        { pageNum: 1, pageSize: 5 },
        'standardFile'
      )
      this.defaultPost(
        '/tianshu-api/bigdata/standard/base/page',
        { pageNum: 1, pageSize: 5, status: '0,1,2,3,4,5,100' },
        'standardList'
      )
      this.defaultPost(
        '/tianshu-api/bigdata/standard/relation/page',
        { pageNum: 1, pageSize: 5 },
        'standardRelation'
      )
      this.defaultPost(
        '/tianshu-api/bigdata/quality/job/list',
        {
          pageNum: 1,
          pageSize: 5
          // tenantId: userInfo.tenant.id
        },
        'qualityWork'
      )
      this.defaultFetch(
        '/tianshu-api/bigdata/authority/searchGroup?pageNum=1&pageSize=5',
        'dataAuth'
      )
      this.defaultPost(
        '/tianshu-api/bigdata/quality/job/process/page',
        { pageNum: 1, pageSize: 5 },
        'qualityTest'
      )
      this.defaultFetch(
        '/tianshu-api/bigdata/sensitive/rule/page?pageNum=1&pageSize=5',
        'dataMaskingRules'
      )
      this.defaultFetch(
        '/tianshu-api/bigdata/sensitive/config/page?pageNum=1&pageSize=5',
        'dataMaskingConfig'
      )
    },
    async fetchStats() {
      try {
        const res = await fetch(
          '/tianshu-api/analysis/semantic/graph/getStats',
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + getToken()
            }
          }
        )
        const data = await res.json()
        if (data?.data) {
          this.stats[0].value = data.data.nodeCount ?? '—'
          this.stats[1].value = data.data.relationCount ?? '—'
          this.stats[2].value = '0'
        }
      } catch (e) {
        /* ignore */
      }
    },
    async fetchSources() {
      try {
        const res = await fetch(
          `/tianshu-api/system/table/listByPage?pageSize=5`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + getToken()
            }
          }
        )
        const data = await res.json()
        if (data) {
          this.dbSourceObj = {
            datasourceList: data?.rows || [],
            total: data?.total || 0
          }
          this.stats[2].value = this.dbSourceObj.total
        }
      } catch (e) {
        /* ignore */
      }
    },
    async fetchIndustryList() {
      try {
        const res = await fetch(
          '/tianshu-api/analysis/semantic/library/industry/stats'
        )
        const data = await res.json()
        if (Array.isArray(data?.data)) this.industryList = data.data
      } catch (e) {
        /* ignore */
      }
    },
    checkTenantVisibility() {
      const currentTenant = this.$store.state.user.currentTenant;
      const tenantId = currentTenant && currentTenant.id;
      if (tenantId != null) {
        this.showModelingCard = tenantId != 100022362;
      }
    },
  },
  computed: {
    industryTotal() {
      return {
        industries: this.industryList.length,
        objects: this.industryList.reduce(
          (s, item) => s + (item.totalNodes || 0),
          0
        )
      }
    }
  },
  mounted() {
    console.log("[  ]-738", 111);
    this.fetchStats();
    this.fetchSources();
    this.fetchIndustryList();
    this.fetchAllGovernanceData();
    this.checkTenantVisibility();
  },
};
</script>

<style lang="scss" scoped>
.gov-shell {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.gov-tab-bar {
  display: flex;
  gap: 4px;
  padding: 8px 20px 8px;
  overflow-x: auto;
  white-space: nowrap;
  flex-wrap: nowrap;
  flex-shrink: 0;
}

.gov-tab {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 12px;
  line-height: 1;
  background: #ffffff;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  color: #595959;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.8);
  }

  &.active {
    background-image: linear-gradient(270deg, #4a5ff3 0%, #4e86ff 100%);
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
    .tab-title {
      color: #fff;
    }
    .tab-close {
      color: #fff;
    }
  }
}

.tab-title {
  font-size: 13px;
  color: #666;
  font-family: PingFangSC-Regular;
}
.tab-close {
  font-size: 12px;
  color: #999;
}

.gov-iframe-wrap {
  flex: 1;
  min-height: 0;
  padding: 12px;
}
.gov-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

/* ── original styles ── */
.stats-row {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 24px;
  .stat-card {
    background: #fff;
    border-radius: 12px;
    padding: 12px 20px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    .stat-icon {
      width: 36px;
      height: 36px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      i {
        font-size: 26px;
      }
    }
    .stat-info {
      display: flex;
      flex-direction: column;
      .stat-value {
        font-size: 20px;
        font-weight: 600;
        color: #1a1a2e;
        line-height: 1.2;
      }
      .stat-label {
        font-size: 12px;
        color: #999;
        margin-top: 4px;
      }
    }
  }
}

.feature-cards {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
.feature-card {
  background: rgba(255, 255, 255, 0.7);
  border-radius: 20px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 14px 32px rgba(113, 154, 255, 0.12);
  min-width: 0;
  overflow: hidden;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 32px rgba(74, 95, 243, 0.14);
  }
  &.full-width {
    grid-column: 1 / -1;
  }
  &.tall {
    min-height: 440px;
    display: flex;
    flex-direction: column;
  }
}
.feature-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  .feature-card-title {
    display: flex;
    align-items: center;
    gap: 12px;
    h4 {
      font-size: 15px;
      font-weight: 600;
      color: #1e293b;
      margin: 0 0 2px 0;
    }
    p {
      font-size: 12px;
      color: #94a3b8;
      margin: 0;
    }
  }
  .feature-icon {
    display: inline-flex;
    width: 44px;
    height: 44px;
    align-items: center;
    justify-content: center;
    border-radius: 16px;
    box-shadow: 0 6px 14px rgba(74, 95, 243, 0.22);
    i {
      font-size: 18px;
      color: #fff;
    }
    &.modeling {
      background: linear-gradient(135deg, #4e86ff, #4a5ff3);
    }
    &.ontology {
      background: linear-gradient(135deg, #4e86ff, #4a5ff3);
    }
    &.metadata {
      background: linear-gradient(135deg, #4e86ff, #4a5ff3);
    }
    &.lineage {
      background: linear-gradient(135deg, #4e86ff, #4a5ff3);
    }
    &.library {
      background: linear-gradient(135deg, #4e86ff, #4a5ff3);
    }
  }
  .feature-cta {
    font-size: 12px;
    font-weight: 500;
    color: #3370ff;
    background: #eef2ff;
    border-radius: 999px;
    padding: 6px 14px;
    cursor: pointer;
    transition: background 0.2s;
    white-space: nowrap;
    i {
      font-size: 10px;
      margin-left: 2px;
    }
    &:hover {
      background: #dee6ff;
    }
  }
}
.steps-row {
  display: flex;
  align-items: flex-start;
  gap: 0;
  flex-wrap: wrap;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 12px;
  border: 1px solid #f1f5f9;
  padding: 20px 24px;
}
.step-col {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px;
  flex: 1;
}
.step-connector {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px 0 8px;
}
.step-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
  &.done {
    background: #3370ff;
    color: #fff;
  }
  &.active {
    background: #3370ff;
    color: #fff;
  }
  &:not(.done):not(.active) {
    background: #e2e8f0;
    color: #94a3b8;
  }
}
.step-content {
  display: flex;
  flex-direction: column;
  .step-title {
    font-size: 13px;
    font-weight: 600;
    color: #334155;
  }
  .step-desc {
    font-size: 11px;
    color: #94a3b8;
    line-height: 1.4;
    white-space: pre-line;
    margin-top: 2px;
  }
}
.ontology-graph-body {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.ontology-graph-wrap {
  flex: 1;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid #f1f5f9;
  border-radius: 12px;
  overflow: hidden;
  min-height: 280px;
  .graph-iframe {
    width: 100%;
    height: 100%;
    min-height: 280px;
    display: block;
  }
}
.metadata-preview-wrap {
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid #f1f5f9;
  border-radius: 12px;
  overflow: hidden;
}
.metadata-preview-scroll {
  height: 240px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  &:hover {
    scrollbar-color: rgba(148, 163, 184, 0.5) transparent;
  }
  &::-webkit-scrollbar {
    width: 4px;
    background: transparent;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 2px;
  }
  &:hover::-webkit-scrollbar-thumb {
    background: rgba(148, 163, 184, 0.5);
  }
}
.metadata-row {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 6px 16px;
  border-bottom: 1px solid #f1f5f9;
  overflow: hidden;
  &:hover {
    background: rgba(255, 255, 255, 0.8);
  }
  &:last-child {
    border-bottom: none;
  }
  .metadata-name {
    font-size: 12px;
    line-height: 16px;
    color: #334155;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    i {
      margin-right: 6px;
    }
  }
  .metadata-count {
    font-size: 12px;
    border-radius: 999px;
    padding: 2px 0;
    color: #888;
    padding-left: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.preview-footer {
  text-align: center;
  font-size: 12px;
  color: #94a3b8;
  padding: 10px 12px;
  border-top: 1px solid #f1f5f9;
  background: rgba(255, 255, 255, 0.8);
}
.library-preview {
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid #f1f5f9;
  border-radius: 12px;
  overflow: hidden;
  padding: 12px;
}
.library-item {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border-radius: 12px;
  padding: 12px;
  border: 1px solid #f1f5f9;
  margin-bottom: 8px;
  cursor: pointer;
  &:hover {
    border-color: rgba(74, 95, 243, 0.2);
  }
  &:last-child {
    margin-bottom: 0;
  }
}
.library-icon {
  display: inline-flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  flex-shrink: 0;
}
.library-info {
  flex: 1;
  min-width: 0;
  .library-name {
    font-size: 13px;
    font-weight: 500;
    color: #334155;
  }
  .library-desc {
    font-size: 11px;
    color: #94a3b8;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.library-obj-count {
  font-size: 11px;
  font-weight: 500;
  color: #7c3aed;
  background: #faf5ff;
  border-radius: 999px;
  padding: 2px 10px;
  white-space: nowrap;
}
.library-footer {
  text-align: center;
  font-size: 12px;
  color: #94a3b8;
  padding-top: 10px;
}

.open-tab-bar {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.open-tab-link {
  display: inline-flex;
  align-items: center;
  padding: 33px 66px;
  border-radius: 8px;
  border: 1px solid rgba(74, 95, 243, 0.2);
  background: linear-gradient(
    135deg,
    rgba(74, 95, 243, 0.06),
    rgba(45, 127, 249, 0.03)
  );
  color: #4a5ff3;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: linear-gradient(
      135deg,
      rgba(74, 95, 243, 0.12),
      rgba(45, 127, 249, 0.08)
    );
    border-color: rgba(74, 95, 243, 0.4);
    transform: translateY(-1px);
  }
}

@media (max-width: 900px) {
  .step-col {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .step-connector {
    display: none;
  }
}
</style>
